import { SecurityWrapper } from "../../components";

export default function SecurityPage() {
  return (
    <>
      <SecurityWrapper />
    </>
  );
}
